import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Field } from 'react-final-form';
import FieldGroup from '../../../FieldGroup.jsx';
import RadioOptionsField from '../../../RadioOptionsField.jsx';

function OrgStakeholderForm({
  stakeholderTypeOptions,
  values,
  preselectedType,
}) {
  return (
    <React.Fragment>
      {!preselectedType ? (
        <Row>
          <Col xs={12}>
            <RadioOptionsField
              id="objectType"
              label=""
              name="objectType"
              options={stakeholderTypeOptions}
            />
          </Col>
        </Row>
      ) : null}

      {values.objectType ? (
        values.objectType === 'group' ? (
          <Row>
            <Col xs={12}>
              <Field
                id="name"
                name="name"
                label="Name"
                placeholder="Name"
                type="text"
                component={FieldGroup}
              />
            </Col>
          </Row>
        ) : (
          <Row>
            <Col xs={12}>
              <Field
                id="firstName"
                name="firstName"
                label="First Name"
                placeholder="Enter the First Name"
                type="text"
                component={FieldGroup}
              />
            </Col>

            <Col xs={12}>
              <Field
                id="lastName"
                name="lastName"
                label="Last Name"
                placeholder="Enter the Last Name"
                type="text"
                component={FieldGroup}
              />
            </Col>
          </Row>
        )
      ) : null}

      <Row>
        <Col xs={12}>
          <Field
            id="email"
            name="email"
            label="Email"
            placeholder="Enter the Email"
            type="email"
            component={FieldGroup}
          />
        </Col>
      </Row>
    </React.Fragment>
  );
}

export default OrgStakeholderForm;
